<template>
    <v-text-field
        :value="display"
        :disabled="disabled"
        :label="label"
        :outline="outline"
        :class="inputClass"
        placeholder="DD/MM/YYYY"
        maxlength="10"
        inputmode="numeric"
        hide-details
        rounded
        clearable
        @input="onInput"
    />
</template>

<script>
import moment from 'moment'

// v-model is always '' or a valid 'YYYY-MM-DD' date.
// 'invalid' is emitted with true when the typed text is not a valid date.
export default {
    name: 'DateMaskInput',
    props: {
        value: String,
        onlyPreviousDates: Boolean,
        disabled: Boolean,
        label: String,
        outline: {
            type: Boolean,
            default: true,
        },
        inputClass: [String, Array, Object],
    },
    data() {
        return {
            display: '',
            lastEmitted: undefined,
        }
    },
    watch: {
        value: function (value) {
            if (value !== this.lastEmitted) {
                this.syncFromValue(value)
            }
        },
    },
    created: function () {
        this.syncFromValue(this.value)
    },
    methods: {
        isAllowedDate: function (date) {
            return date.isValid() && date.year() >= 1900 && !(this.onlyPreviousDates && date.isAfter(moment(), 'day'))
        },
        syncFromValue: function (value) {
            this.lastEmitted = value
            if (!value) {
                this.display = ''
                this.$emit('invalid', false)
                return
            }
            const date = moment(value, ['YYYY-M-D', 'YYYY-M-D HH:mm:ss', 'DD/MM/YYYY'], true)
            if (!date.isValid()) {
                // Unknown format: keep the value untouched and block the form
                this.display = value
                this.$emit('invalid', true)
                return
            }
            this.display = date.format('DD/MM/YYYY')
            this.lastEmitted = date.format('YYYY-MM-DD')
            if (this.lastEmitted !== value) {
                this.$emit('input', this.lastEmitted)
            }
            this.$emit('invalid', !this.isAllowedDate(date))
        },
        onInput: function (text) {
            const digits = (text || '').replace(/\D/g, '').substring(0, 8)
            const masked = digits.replace(/^(\d{2})(\d)/, '$1/$2').replace(/^(\d{2}\/\d{2})(\d)/, '$1/$2')
            // Force re-render when the masked text equals the previous one (e.g. a letter was stripped)
            this.display = text || ''
            this.$nextTick(() => {
                this.display = masked
            })

            const date = masked.length === 10 ? moment(masked, 'DD/MM/YYYY', true) : null
            const valid = date && this.isAllowedDate(date)
            this.lastEmitted = valid ? date.format('YYYY-MM-DD') : ''
            this.$emit('input', this.lastEmitted)
            this.$emit('invalid', !!masked && !valid)
        },
    },
}
</script>
